// extracted by mini-css-extract-plugin
module.exports = {"total":"Total-module--total--c9Bl7"};